"use client";

import { ErrorDisplay } from "app/components/ErrorDisplay";
import { useCardInfo } from "app/hooks";
import { ReactNode, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import "styles/charge.css";
import { InputChkIcon } from "app/components/Icons";
import Link from "next/link";
import CardBrandIcon from "app/components/CardBrandIcon";

type PaymentMethod = {
  name: string;
  icon: ReactNode;
  last4?: string;
  brand?: string;
};

export default function ChargePaymentMethods({ isDialog }: { isDialog?: boolean }) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { cardInfo, isLoading, error } = useCardInfo();

  // TODO: 支払い方法が増えたら最後に使用した支払い方法を初期値にする
  //   const [lastUsedMethod, setLastUsedMethod] = useState({ name: "クレジットカード", icon: "" });

  // TODO: 支払い方法が増えたらチェックボックス選択時の処理を追加
  // const [methodCheckedList, setMethodCheckedList] = useState<boolean[]>(
  //   new Array(methodList.length).fill(false),
  // );
  // const handleCheckbox = (index: number) => {
  //   const tmpList = new Array(methodCheckedList.length).fill(false);
  //   const prevCheckedIndex = methodCheckedList.indexOf(true);
  //   if (prevCheckedIndex === -1) {
  //     tmpList[index] = true;
  //     setMethodCheckedList([...tmpList]);
  //   } else if (index === prevCheckedIndex) {
  //     return;
  //   } else {
  //     tmpList[prevCheckedIndex] = false;
  //     tmpList[index] = true;
  //     setMethodCheckedList([...tmpList]);
  //   }
  //   setLastUsedMethod(methodList[index]);
  // };

  if (isLoading) return <></>;
  if (error) return <ErrorDisplay message="お支払い情報の取得時にエラーが発生しました" />;

  // TODO: お支払い方法のリスト
  const methodList: PaymentMethod[] = [
    {
      name: "クレジットカード",
      icon: <CardBrandIcon brand={cardInfo.brand} className="charge-methods-list-item-icon" />,
      last4: cardInfo.last4 || "",
      brand: cardInfo.brand || "",
    },
    // { name: "PayPay", icon: <Image src="" alt="" /> },
    // { name: "Apple Pay", icon: <Image src="" alt="" /> },
    // { name: "Google Pay", icon: <Image src="" alt="" /> },
    // { name: "d払い", icon: <Image src="" alt="" /> },
    // { name: "auかんたん決済", icon: <Image src="" alt="" /> },
    // { name: "Softbankまとめて支払い", icon: <Image src="" alt="" /> },
  ];

  return (
    <div className={"charge-methods" + (isDialog ? " mode-dialog" : "")}>
      <div className="charge-methods-h">お支払方法</div>
      <div className={"charge-methods-content" + (isOpen ? " mode-open" : "")}>
        <div
          className={
            "charge-methods-box" + (isOpen ? " mode-open" : "") + (isDialog ? " mode-dialog" : "")
          }
        >
          {isOpen ? (
            <ul className={"charge-methods-list" + (isDialog ? " mode-dialog" : "")}>
              {methodList.map((method, index) => {
                return (
                  <li key={index} className="charge-methods-list-item">
                    <label className="charge-methods-list-item-label">
                      <input
                        type="radio"
                        onChange={() => {
                          // handleCheckbox(index);
                        }}
                        // TODO: 支払い方法が増えたら選択式にする
                        // checked={methodCheckedList[index]}
                        checked={true}
                        className="charge-methods-list-item-input"
                      />
                      <InputChkIcon size={28} className="charge-methods-list-item-check-icon" />
                      <div className="charge-methods-list-item-content">
                        <div>{method.name}</div>
                        {method.icon}
                        {method.last4 && (
                          <span className="charge-methods-list-item-last4">
                            xxxx-xxxx-xxxx-{method.last4}
                          </span>
                        )}
                        {method.last4 && (
                          <span className="charge-methods-list-item-link-wrapper">
                            <Link href="/users/cardinfo" className="charge-methods-list-item-link">
                              カードを変更・削除する
                            </Link>
                          </span>
                        )}
                      </div>
                    </label>
                  </li>
                );
              })}
            </ul>
          ) : (
            //  TODO: 支払い方法が増えたらlastUsedMethodで置き換える
            <>
              <div className="charge-methods-selected">
                <span>{methodList[0].name}</span>
                {methodList[0].icon}
              </div>
              {methodList[0].last4 && (
                <span className="charge-methods-selected-last4">
                  xxxx-xxxx-xxxx-{methodList[0].last4}
                </span>
              )}
            </>
          )}
        </div>
        <div className={"charge-methods-toggle-button-wrapper" + (isOpen ? " mode-open" : "")}>
          <button
            className={"charge-methods-toggle-button" + (isOpen ? " mode-open" : "")}
            onClick={() => {
              setIsOpen((prev) => !prev);
            }}
          >
            {isOpen ? (
              <>
                <span className="charge-methods-toggle-button-text">閉じる</span>
                <MdKeyboardArrowUp size={32} className="charge-methods-toggle-button-icon" />
              </>
            ) : (
              <>
                {isDialog ? (
                  <span className="charge-methods-toggle-button-text">変更</span>
                ) : (
                  <>
                    <span className="charge-methods-toggle-button-text mode-pc">
                      他のお支払方法を選ぶ
                    </span>
                    <span className="charge-methods-toggle-button-text mode-sp">変更</span>
                  </>
                )}
                <MdKeyboardArrowDown size={32} className="charge-methods-toggle-button-icon" />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
